import type {LightAnimation} from "@/dungeons/model/DungeonGeometry.ts";
import LightValueSlider from "./LightValueSlider.tsx";

export default function LightAnimationControl({animation, onPreview, onCommit, disabled = false, compact = false}: {
    animation?: LightAnimation | null;
    onPreview: (animation: LightAnimation | null) => void;
    onCommit: (animation: LightAnimation | null) => void;
    disabled?: boolean;
    compact?: boolean;
}) {
    return <div className="space-y-2">
        <label className={`block space-y-1 ${compact ? "text-xs" : "text-sm"}`}>Lichteffekt
            <select value={animation?.effect ?? "STATIC"} disabled={disabled}
                className="h-8 w-full rounded-md border border-input bg-surface px-2"
                onChange={event => onCommit(event.target.value === "STATIC" ? null : {
                    effect: event.target.value as LightAnimation["effect"],
                    strength: animation?.strength ?? 0.3, speed: animation?.speed ?? 1,
                })}>
                <option value="STATIC">Statisch</option>
                <option value="FLICKER">Flackern</option>
                <option value="PULSE">Pulsieren</option>
            </select>
        </label>
        {animation && <>
            <LightValueSlider label="Effektstärke" value={animation.strength} min={0} max={1} step={0.01}
                compact={compact} disabled={disabled} format={value => `${Math.round(value * 100)} %`}
                onPreview={strength => onPreview({...animation, strength})}
                onCommit={strength => onCommit({...animation, strength})}/>
            <LightValueSlider label="Geschwindigkeit" value={animation.speed} min={0.1} max={5} step={0.1}
                compact={compact} disabled={disabled} format={value => `${value.toFixed(1)}×`}
                onPreview={speed => onPreview({...animation, speed})}
                onCommit={speed => onCommit({...animation, speed})}/>
        </>}
    </div>;
}
